import React, { useEffect, useState, useRef } from "react";
import "../Css/HomePage.css";
import Authentic from "../Component/Home/Authentic";
import HomeVenue from "../Component/Home/HomeVenue";
import HomeSearches from "../Component/Home/HomeSearches";
import WeddingCategory from "../Component/NewHome/WeddingCategory";
import AppDownload from "../Component/Home/AppDownload";
import { Button, Select } from "antd";
import HomeBlog from "../Component/Home/HomeBlog";
import Footer from "../Component/FooterCom/Footer";
import axios from "axios";
import Typewriter from "typewriter-effect/dist/core";
import NewHomeCategory from "../Component/NewHome/NewHomeCategory";
import LocationVendor from "../Component/NewHome/LocationVendor";
import HomeMainVendors from "../Component/Home/HomeMainVendors";
import HomeCommunity from "../Component/Home/HomeCommunity";
import videobanner from "../Images/best drone shot in wedding.mp4";
import destination_wedding from "../Images/banner/wedding_adda_main-banner_image.webp";
import NewBanner from "../Component/NewHome/NewBanner";

import NewCommunity from "../Component/NewHome/NewCommunity";


const HomePage = () => {
  const typewriterRef = useRef(null);

  const overlayRef = useRef();
  useEffect(() => {
    const handleScroll = () => {
      if (overlayRef.current) {
        if (window.scrollY > 100) {
          overlayRef.current.classList.add("scrolled");
        } else {
          overlayRef.current.classList.remove("scrolled");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const categoryFetch = async () => {
  //   try {
  //     const response = await axios.get(
  //       "https://api.weddingzadda.com/api/categories"
  //     );
  //     setCategoryList(response.data);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // useEffect(() => {
  //   const fetchLocation = async () => {
  //     try {
  //       const response = await axios.get(
  //         `https://api.weddingzadda.com/api/cities`
  //       );
  //       setLocation(response?.data);
  //     } catch (error) {
  //       console.error("Error Fetching Sub Category List:", error);
  //     }
  //   };

  //   fetchLocation();
  // }, []);

  useEffect(() => {
    const typewriter = new Typewriter(typewriterRef.current, {
      loop: true,
    });

    typewriter
      .typeString("Web Developer")
      .pauseFor(2500)
      .deleteAll()
      .typeString("Web Designer")
      .pauseFor(2500)
      .deleteAll()
      .typeString("<strong>FrontEnd Developer</strong>")
      .pauseFor(2500)
      .start();
  }, []);

  useEffect(() => {
    if (!typewriterRef.current) return;

    const typewriter = new Typewriter(typewriterRef.current, {
      loop: true,
      delay: 75,
    });

    typewriter
      .typeString("Find Trusted Wedding Vendors")
      .pauseFor(2000)
      .deleteAll()
      .typeString("Plan Your Dream Wedding Effortlessly")
      .pauseFor(2000)
      .deleteAll()
      .typeString("Celebrate Love, Your Way")
      .pauseFor(2000)
      .deleteAll()
      .start();

    return () => typewriter.stop(); // Cleanup
  }, []);


  

  return (
    <>
      <NewBanner />
      <HomeSearches />
      <WeddingCategory />
      <HomeMainVendors
        title={"Top Event Venues Around You"}
        desc={
          "Browse handpicked venues in your area — for weddings, parties, and everything in between."
        }
        type={"venues"}
        bg={true}
      />
      {/* <HomeOtherFunction data={data} /> */}
      {/* <NewHomeClass /> */}
      <NewCommunity />

      {/* <NewHomeCategory />  */}
      {/* <LocationVendor /> */}
      <HomeVenue />
      <HomeMainVendors
        title={"Featured Vendors"}
        desc={
          "These are the professionals our users love — trusted, reviewed, and ready to make your event perfect."
        }
        type="all"
        bg={false}
      />

      {/* <HomeCommunity /> */}
      <AppDownload />
      <HomeBlog />
    </>
  );
};

export default HomePage;
